import { Icon } from 'types/Icon';

export const IconSlash = ({ ...restProps }: Icon) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
    <path d="M13 5L8 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
